import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import LoginComponent from '../component/login_page/LoginPage';
import actions from '../redux/actions/login';

const mapStateToProps = (state) => ({
  login: state.login,
});

const mapDispatchToProps = (dispatch) => ({
  onLoginQR1Action: (params) => {
    dispatch(actions.loginQR1(params));
  },
  onLoginQR2Action: (params) => {
		  dispatch(actions.loginQR2(params));
  },
  onLoginQR3Action: (params) => {
    dispatch(actions.loginQR3(params));
  },
  onLoginNormal: (params) => {
    dispatch(actions.loginNormal(params));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginComponent));
